'use client';

import { useEffect, useState } from 'react';

import { ChatData } from '@/slw/entities/chat';
import { cn } from '@/slw/shared/lib/utils';
import { Button, buttonVariants } from '@/slw/shared/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/slw/shared/ui/tooltip';
import { onlineStatusService } from '@/slw/shared/lib/firebase/online-status';

import { BubbleAvatar } from '../common/bubble-avatar.ui';

interface CollapsedChatItemProps {
  chat: ChatData;
  isSelected: boolean;
  onClick: () => void;
}

export function CollapsedChatItem({ chat, isSelected, onClick }: CollapsedChatItemProps) {
  const [isOnline, setIsOnline] = useState(chat?.user?.isOnline || false);

  // Theo dõi trạng thái online của người dùng
  useEffect(() => {
    if (!chat?.user?.id) return;

    const unsubscribe = onlineStatusService.getOnlineStatus(chat?.user?.id, (online) => {
      setIsOnline(online);
    });

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [chat?.user?.id]);

  if (!chat?.user?.id) {
    return;
  }

  return (
    <TooltipProvider>
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild>
          <Button
            onClick={onClick}
            className={cn(
              buttonVariants({
                color: isSelected ? 'secondary' : 'light',
                variant: 'outline',
                size: 'icon',
              }),
              'h-11 w-11 md:h-16 md:w-16 border-0 relative p-0',
            )}
            color='light'
          >
            <div className='relative'>
              <BubbleAvatar src={chat.user.avatar} name={chat.user.username} />
              <div
                className={cn(
                  'absolute bottom-0 right-0 h-3 w-3 rounded-full border-2 border-white',
                  isOnline ? 'bg-green-500' : 'bg-gray-400',
                )}
                title={isOnline ? 'Online' : 'Offline'}
              />
            </div>
            <span className='sr-only'>{chat.user.username}</span>
          </Button>
        </TooltipTrigger>
        <TooltipContent side='right' className='flex items-center gap-4'>
          <span>{chat.user.username}</span>
          <span className={cn('h-2 w-2 rounded-full', isOnline ? 'bg-green-500' : 'bg-gray-400')}></span>
          <span>{isOnline ? 'Online' : 'Offline'}</span>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
